// frontend/src/pages/MatchScoring/ScoringPad.js
//
// The bottom pad of buttons. Calls back to parent for each tap.
// Wd / Nb / B / Lb / W open modals; numeric runs (0-3) commit directly
// or chain to wagon-wheel modal if detailMode is on.
//
// For 4/6 we ALWAYS open the wagon-wheel because boundary direction is
// the most useful detail to record.

import React from 'react';

export default function ScoringPad({
  detailMode,
  onRun,         // (runs:number) => void
  onRunOther,    // () => void — open picker for arbitrary runs (overthrows, 5/7)
  onBoundary,    // (4|6) => void
  onExtra,       // ('wd'|'nb'|'b'|'lb') => void
  onWicket,      // () => void
  onUndo,
  onToggleDetail,
  isFreeHit,     // unused for now; could disable some buttons during free-hit
  busy,
}) {
  return (
    <div className="sc-pad">
      <div className="sc-grid-runs">
        <button className="sc-key" disabled={busy} onClick={() => onRun(0)}>
          <span className="sc-label">0</span>
          <span className="sc-sub">dot</span>
        </button>
        <button className="sc-key" disabled={busy} onClick={() => onRun(1)}>
          <span className="sc-label">1</span>
        </button>
        <button className="sc-key" disabled={busy} onClick={() => onRun(2)}>
          <span className="sc-label">2</span>
        </button>
        <button className="sc-key" disabled={busy} onClick={() => onRun(3)}>
          <span className="sc-label">3</span>
        </button>
        <button className="sc-key" disabled={busy} onClick={() => onRunOther && onRunOther()}>
          <span className="sc-label">5+</span>
          <span className="sc-sub">overthrow</span>
        </button>
        <button className="sc-key sc-four" disabled={busy} onClick={() => onBoundary(4)}>
          <span className="sc-label">4</span>
          <span className="sc-sub">boundary</span>
        </button>
        <button className="sc-key sc-six" disabled={busy} onClick={() => onBoundary(6)}>
          <span className="sc-label">6</span>
          <span className="sc-sub">over</span>
        </button>
        <button className="sc-key sc-wkt" disabled={busy} onClick={onWicket}>
          <span className="sc-label">WICKET</span>
        </button>
      </div>

      <div className="sc-grid-extras">
        <button className="sc-key sc-extra-key" disabled={busy} onClick={() => onExtra('wd')}>
          <span className="sc-label">Wd</span>
          <span className="sc-sub">wide</span>
        </button>
        <button className="sc-key sc-extra-key" disabled={busy} onClick={() => onExtra('nb')}>
          <span className="sc-label">Nb</span>
          <span className="sc-sub">no ball</span>
        </button>
        <button className="sc-key sc-extra-key" disabled={busy} onClick={() => onExtra('b')}>
          <span className="sc-label" style={{ color: 'var(--sc-text-mute)' }}>B</span>
          <span className="sc-sub">bye</span>
        </button>
        <button className="sc-key sc-extra-key" disabled={busy} onClick={() => onExtra('lb')}>
          <span className="sc-label" style={{ color: 'var(--sc-text-mute)' }}>Lb</span>
          <span className="sc-sub">leg bye</span>
        </button>
      </div>

      <div className="sc-grid-actions">
        <button className="sc-key sc-action" disabled={busy} onClick={onUndo}>
          ↶ Undo
        </button>
        <button className="sc-key sc-action" disabled={busy} onClick={() => alert('Tap any ball above to edit')}>
          ✎ Edit
        </button>
        <button
          className={`sc-key sc-action ${detailMode ? 'sc-primary' : ''}`}
          onClick={onToggleDetail}
          aria-pressed={detailMode}
        >
          {detailMode ? '⊕ Detail ON' : '○ Detail OFF'}
        </button>
      </div>
    </div>
  );
}
